module.exports = __webpack_public_path__ + "static/img/result_ls_lens_up.82529af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/result/result_ls_lens_up.jpg
// module id = e4MZ
// module chunks = 3